<template>
  <div>
    <div
      class="modal fade"
      id="modal-email-template"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("mail_form.emailTemplateList") }}
            </h4>
          </div>
          <div class="modal-body">
            <div>
              <div class="box-body">
                <div>
                  <button
                    class="btn btn-primary btn-sm pull-right"
                    style="margin-left: 6px;"
                    @click="onAddNewTemplate"
                  >
                    <i class="glyphicon glyphicon-plus"></i>
                    {{ $t("common.addnew") }}
                  </button>
                </div>
                <b-table
                  striped
                  hover
                  :fields="fields"
                  :items="templateEmailList"
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(content)="row">
                    <div v-html="row.item.content"></div>
                  </template>
                  <template #cell(usedDefault)="row">
                    <div v-if="row.item.usedDefault">
                      <i
                        class="glyphicon glyphicon-ok text-success"
                        style="font-size: 20px"
                      ></i>
                    </div>
                    <div v-else>
                      <i
                        class="glyphicon glyphicon-remove text-danger"
                        style="font-size: 20px"
                      ></i>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="btn-group">
                      <button
                        v-if="!row.item.usedDefault"
                        class="btn btn-success pull-left"
                        style="margin-left: 6px;"
                        @click="onEnableTemplate(row.item)"
                      >
                        <i class="glyphicon glyphicon-ok"></i>
                      </button>
                      <button
                        v-if="
                          has_perm('update_email_template') ||
                            GET_ACCOUNT_DATA.group_id == 1
                        "
                        @click="onHandleEdit(row)"
                        class="btn btn-primary"
                        style="margin-left: 6px"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                      <button
                        v-if="
                          has_perm('delete_email_template') ||
                            GET_ACCOUNT_DATA.group_id == 1
                        "
                        @click="onDeleteTemplate(row.item)"
                        class="btn btn-danger"
                        style="margin-left: 6px"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="box-footer clearfix">
                <paginator
                  :totalItem="paginateData.totalItem"
                  :currentPage="paginateData.currentPage"
                  :pageSize="paginateData.pageSize"
                  :totalPage="paginateData.totalPage"
                  @onpaginate="onPagination"
                />
              </div>
            </div>
            <!--  -->
            <lte-modal
              v-show="isModalVisible"
              @onConfirm="onConfirmDeleteTemplate"
              @close="closeModal"
              v-for="obj in objModal"
              :key="obj.id"
              :item="obj"
            ></lte-modal>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <email-template-detail
      ref="emailTemplateDetail"
      @callbackEmailTemplateList="callbackEmailTemplateList"
    />
    <!--  -->
    <div class="modal fade" :ref="`modal-pkg-tp`">
      <div class="modal-dialog"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import Paginator from "@/components/CustomPaginator.vue";
import EmailTemplateDetail from "./EmailTemplateDetail";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-modal": LTEModal,
    paginator: Paginator,
    EmailTemplateDetail
  },
  data: () => ({
    isLoading: false,
    emailTemplateSelect: null,
    isModalVisible: false,
    objModal: [
      {
        title: "documentation.inform_modal[0].title",
        body: "common.delete_modal.content",
        buttonNo: "documentation.inform_modal[0].modal_btn[0].cancel",
        buttonYes: "documentation.inform_modal[0].modal_btn[0].confirm",
        styleType: "default"
      }
    ],
    categoryId: null,
    templateEmailList: [],
    fields: [
      {
        key: "STT",
        label: "STT",
        sortable: true,
        class: "text-center",
        tdClass: "stt"
      },
      {
        key: "name",
        label: "mail_form.form_name",
        sortable: true,
        class: "text-center"
      },
      {
        key: "subject",
        label: "mail_form.subject",
        sortable: true,
        class: "text-center"
      },
      // {
      //   key: "content",
      //   label: this.$t("mail_form.content"),
      //   sortable: true,
      //   class: "align-left"
      // },
      // {
      //   key: "active",
      //   label: this.$t("mail_form.active"),
      //   sortable: true,
      //   class: "text-center"
      // },
      {
        key: "classify",
        label: "mail_form.classify",
        sortable: true,
        class: "text-center"
      },
      {
        sortable: false,
        label: "templateNotification.usedDefault",
        key: "usedDefault",
        class: "text-center"
      },
      {
        key: "actions",
        label: "mail_form.action",
        class: "actions_style"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    pkg_tp_data: {
      id: 0
    }
  }),
  watch: {
    GET_TEMPLATE_EMAIL_DATA: function() {
      let paginate = this.GET_TEMPLATE_EMAIL_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.templateEmailList = [];
      this.GET_TEMPLATE_EMAIL_DATA.results.forEach((tp, idx) => {
        let data = {
          STT: idx + 1 + (paginate.currentPage - 1) * paginate.pageSize,
          name: utils.spliceString(tp.name, 50),
          id: tp.id,
          subject: utils.spliceString(tp.subject, 70),
          content: tp.content,
          active: tp.active,
          classify: tp.template_email_category,
          email_object: tp.email_object,
          usedDefault: tp.active
        };
        this.templateEmailList.push(data);
      });
      this.totalRows = this.templateEmailList.length;
    }
  },
  computed: {
    ...mapGetters([
      "GET_TEMPLATE_EMAIL_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowModal: function() {
      $("#modal-email-template").modal("show");
    },
    onCloseModal: function() {
      $("#modal-email-template").modal("hide");
    },
    onShowTemplateEmail: function(categoryId) {
      this.categoryId = categoryId;
      this.onShowModal();
      this.getEmailTemplateList(1);
    },
    getEmailTemplateList: function(page) {
      let filter = {
        params: {
          page: page,
          categoryId: this.categoryId
        }
      };
      this.GET_TEMPLATE_DATA(filter)
        .then(function(res) {}.bind(this))
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onAddNewTemplate: function() {
      this.$refs.emailTemplateDetail.onAddNewTemplate(this.categoryId);
    },
    onDeleteTemplate: function(data) {
      this.emailTemplateSelect = data;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirmDeleteTemplate: function() {
      this.DELETE_FORM_EMAIL(this.emailTemplateSelect)
        .then(
          function() {
            this.isModalVisible = false;
            //
            let currentPage = this.paginateData.currentPage;
            let totalPage = this.paginateData.totalPage;
            let page =
              currentPage >= totalPage && this.templateEmailList == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            this.getEmailTemplateList(page);
            this.$emit("callbackEmailCategoryList", true);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            let message = error.response.data.message;
            this.showError(message);
          }.bind(this)
        );
    },
    //
    onPagination: function(data) {
      this.getEmailTemplateList(data);
    },
    callbackEmailTemplateList: function() {
      this.getEmailTemplateList(this.paginateData.currentPage);
      this.$emit("callbackEmailCategoryList", true);
    },
    onHandleEdit: function(row) {
      let id = row.item.id;
      this.$refs.emailTemplateDetail.onDetailTemplate(this.categoryId, id);
    },
    onEnableTemplate: function(data) {
      let template = {
        id: data.id,
        categoryId: this.categoryId
      };
      this.ENABLE_EMAIL_TEMPLATE(template)
        .then(
          function() {
            this.getEmailTemplateList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            let message = error.response.data.message;
            this.showError(message);
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "GET_TEMPLATE_DATA",
      "DELETE_FORM_EMAIL",
      "ENABLE_EMAIL_TEMPLATE"
    ])
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/EmailTemplate.vue